// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f244a37d","239":"3b6222e2","732":"a8b57363"}[chunkId] + ".chunk.js";
};